module.exports = __webpack_public_path__ + "img/categories-and-zones.e7d82c4f.svg";